var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRgbDarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2929,19.707,14,42H6V34L28.293,11.707Zm4.7781-6.636L34.7071,6.707a.9952.9952,0,0,0-1.4142,0L29.707,10.293l8,8,3.581-3.5811C41.6812,14.3188,41.4643,13.4644,41.071,13.071Z",
    fill: "#006443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRgbDarkGreen);
export default __webpack_public_path__ + "static/media/edit_rgb_dark_green.88f7581a6b9ba39cf06d8c5bca34f902.svg";
export { ForwardRef as ReactComponent };